import User from 'models/User'
import apiService from 'services/api.service'
import { useToast } from "vue-toastification"
import i18n from 'i18n'
const toast = useToast();

export default {

    async login (credentials) {
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'login',
                method: 'post',
                params: credentials
            }, true).then(response => {
                if (response.data.data){
                    const curUser = new User(response.data.data)
                    if (curUser.isAuthUser()) {
                        resolve(curUser)
                    } else {
                        reject('no_user_found')
                    }
                } else {
                    reject('no_user_found')
                }
            }).catch((error) => {
                switch(error.data.code){
                    case 0:
                        toast.error(i18n.global.t('auth.invalid_password'));
                    break;
                    default:
                        toast.error(error.data.message);
                    break;
                }
                reject(error)
            })
        })
    },

    async logout () {
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'logout'
            }).then(() => {
                resolve('logout_success')
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getUserBySession () {
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'getuser'
            }).then(response => {
                if (response.data.data){
                    const curUser = new User(response.data.data)
                    if (curUser.isAuthUser()) {
                        resolve(curUser)
                    } else {
                        reject('no_user_found')
                    }
                } else {
                    reject('no_user_found')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getUserByToken (token) {
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'getuser',
                token: token
            }).then(response => {
                if (response.data.data){
                    const curUser = new User(response.data.data)
                    if (curUser.isAuthUser()) {
                        resolve(curUser)
                    } else {
                        reject('no_user_found')
                    }
                } else {
                    reject('no_user_found')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }


}
